export const thumbnailRailStyles = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: '8px',
  padding: '10px 0 6px',
};

export const thumbnailWrapperStyles = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '4px',
  cursor: 'pointer',
};

export const getThumbnailBorderStyles = isSelected => ({
  borderRadius: '4px',
  border: isSelected
    ? ({ palette }) => `2px solid ${palette.primary.main}`
    : ({ palette }) => `2px solid ${palette.divider}`,
  overflow: 'hidden',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: ({ palette }) => palette.background.default,
  '&:hover': {
    borderColor: ({ palette }) => palette.primary.light,
  },
});

export const thumbnailPageLabelStyles = {
  color: ({ palette }) => palette.text.secondary,
};

export const thumbnailImageStyles = {
  display: 'block',
  maxWidth: '70px',
  height: 'auto',
  borderRadius: '2px',
};

export const thumbnailPlaceholderStyles = {
  width: '55px',
  height: '72px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: ({ palette }) => palette.background.secondary,
  borderRadius: '2px',
};

export const thumbnailLoadingStyles = {
  width: '55px',
  height: '72px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

export const loadingErrorStyles = {
  padding: '6px 0',
  color: ({ palette }) => palette.text.secondary,
};

// ── Lightbox ──────────────────────────────────────────────────────────────────

export const lightboxOverlayStyles = {
  position: 'fixed',
  inset: 0,
  zIndex: 1400,
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: ({ palette }) =>
    palette.mode === 'dark' ? 'rgba(0,0,0,0.92)' : 'rgba(0,0,0,0.80)',
};

export const lightboxHeaderStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  padding: '10px 20px',
  backgroundColor: ({ palette }) => palette.background.paper,
  borderBottom: ({ palette }) => `1px solid ${palette.divider}`,
  flexShrink: 0,
};

export const lightboxTitleStyles = {
  flex: 1,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

export const lightboxControlsStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  flexShrink: 0,
};

export const lightboxMainAreaStyles = {
  flex: 1,
  display: 'flex',
  minHeight: 0,
  overflow: 'hidden',
};

export const lightboxScrollAreaStyles = {
  flex: 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  overflowY: 'auto',
  padding: '20px',
};

export const lightboxCanvasWrapperStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: ({ palette }) => palette.background.default,
  borderRadius: '4px',
  overflow: 'hidden',
  boxShadow: ({ palette }) => palette.shadow?.m,
};

export const lightboxThumbnailRailStyles = {
  width: '120px',
  flexShrink: 0,
  overflowY: 'auto',
  padding: '12px 8px',
  borderLeft: ({ palette }) => `1px solid ${palette.divider}`,
  backgroundColor: ({ palette }) => palette.background.paper,
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
};

export const lightboxThumbnailItemStyles = {
  cursor: 'pointer',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '4px',
};

export const getLightboxThumbnailBorderStyles = isActive => ({
  border: isActive
    ? ({ palette }) => `2px solid ${palette.primary.main}`
    : () => '2px solid transparent',
  borderRadius: '4px',
  overflow: 'hidden',
  backgroundColor: ({ palette }) => palette.background.default,
});

export const lightboxImageStyles = {
  display: 'block',
  maxWidth: '100%',
  maxHeight: '80vh',
  height: 'auto',
  borderRadius: '4px',
};
